import React, { useEffect } from "react";
import HeaderNew from "../Component/HeaderNew";
import Banner from "../Component/Storage/Banner";
import PinningNfts from "../Component/Storage/PinningNfts";
import HowItWorks from "../Component/Storage/HowItWorks";
import DevDepin from "../Component/Storage/DevDepin";
import DeveloperFriently from "../Component/Storage/DeveloperFriendly";
import Protocols from "../Component/Storage/Protocols";
import Pricing from "../Component/Storage/Pricing";
import FooterNew from "../Component/FooterNew";

function Storage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
  return (
    <div className="storage">
      <HeaderNew />
      <Banner />
      <PinningNfts />
      <HowItWorks />
      <DevDepin />
      <DeveloperFriently />
      <Protocols />
      <Pricing />
      <FooterNew />
    </div>
  );
}

export default Storage;
